import { DatatableCell, Skeleton } from '@monksflow/monks-ui';
import { TableSkeletonActionsCell, TableSkeletonRow } from '@/shared/ui/data-table';

/**
 * Loading placeholder row for {@link BriefsTable}, matching the Projects/Folders
 * skeleton treatment. Each cell's placeholder mirrors the SHAPE of the real
 * brief row it stands in for — leading icon badge + title, rounded-full type
 * and status pills — so the skeleton reads as a table rather than a block of
 * grey bars. Column order/widths match the `<BriefsTableHeader>` in
 * {@link BriefsTable}.
 *
 * The `<tr>` shell and the `data-testid="briefs-table-skeleton-row"` come from
 * `TableSkeletonRow` via the `testId` override, so existing test queries keep
 * resolving; the trailing 12-wide actions cell comes from
 * `TableSkeletonActionsCell`.
 */
export const BriefsTableSkeletonRow = () => (
  <TableSkeletonRow testId="briefs-table-skeleton-row">
    {/* Title — two stacked text lines, no icon badge. */}
    <DatatableCell>
      <div className="flex flex-col gap-3xs">
        <Skeleton className="h-5 w-40" />
        <Skeleton className="h-4 w-64" />
      </div>
    </DatatableCell>

    {/* Type — plain text. */}
    <DatatableCell>
      <Skeleton className="h-4 w-20" />
    </DatatableCell>

    {/* Status — rounded-full pill. */}
    <DatatableCell>
      <Skeleton className="h-5 w-14 rounded-full" />
    </DatatableCell>

    <TableSkeletonActionsCell />
  </TableSkeletonRow>
);

BriefsTableSkeletonRow.displayName = 'BriefsTableSkeletonRow';
